<template>
    <form ref="form" class="form-enquiry needs-validations" v-on:submit.prevent="submitForm" novalidate>
        <template v-if="showMessage">
            <template v-if="message">
                <p class="alert alert-success" v-html="message"></p>
                <div v-if="refreshBtn" class="d-flex align-items-center justify-content-center">
                    <button v-on:click="reloadPage" type="button" class="btn btn-md btn-primary">
                        Back to form
                    </button>
                </div>
            </template>
            <p v-else-if="error" class="alert alert-danger" v-html="error"></p>
        </template>
        <template v-if="!message">
            <fieldset>
                <div class="row">
                <template v-for="field in formattedFields">
                    <div v-if="field.data_type == 'label'"
                        :key="field.name"
                        class="col-12 mb-4">
                        <h3 class="border-bottom pb-3 mb-3 font-weight-normal">
                            {{ field.title }}
                        </h3>
                        <h5 v-if="!_.isNull(field.help)" class="my-2 text-blue fw-light">{{ field.help }}</h5>
                    </div>
                    <div v-if="field.data_type == 'divider'"
                        :key="field.name"
                        class="col-12">
                        <div class="w-100 border-bottom pb-3 mb-3"></div>
                    </div>
                    <input v-if="field.data_type == 'hidden'"
                        :key="field.name"
                        v-model="formData[field.name]"
                        :id="field.name"
                        :name="field.name"
                        type="hidden"
                        :tabindex="_.get(field, 'tabindex', 1)">
                    <div v-if="field.data_type == 'input-text'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group field">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :placeholder="field.title"
                                :required="!!field.required"
                                class="form-control req"
                                type="text"
                                :tabindex="_.get(field, 'tabindex', 1)">
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-text-lg'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group field">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :placeholder="field.title"
                                :required="!!field.required"
                                class="form-control req"
                                type="text"
                                :tabindex="_.get(field, 'tabindex', 1)">
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-number'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group field">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :placeholder="field.placeholder"
                                :required="!!field.required"
                                class="form-control req"
                                type="number"
                                :tabindex="_.get(field, 'tabindex', 1)">
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-email'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group field">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :placeholder="field.placeholder"
                                :required="!!field.required"
                                class="form-control req"
                                type="email"
                                :tabindex="_.get(field, 'tabindex', 1)">
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-tel'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group field">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :placeholder="field.placeholder"
                                :required="!!field.required"
                                class="form-control req"
                                type="tel"
                                :tabindex="_.get(field, 'tabindex', 1)">
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <select v-model="formData[field.name]"
                                :id="field.name"
                                :name="field.name"
                                :required="!!field.required"
                                class="form-control form-select"
                                :tabindex="_.get(field, 'tabindex', 1)">
                                <option value="">{{ _.isNull(_.get(field, 'placeholder', null)) ? '--Please Select--' : _.get(field, 'placeholder', null) }}</option>
                                <option v-for="option in getSelectValues(field)" :value="option.id" :key="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'refs-selectbox'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <!-- <span v-if="formError[field.name]" class="d-block invalid-feedback mb-2">
                                This field is required
                            </span> -->
                            <refs-radio-list-component v-model="formData[field.name]"
                                :config="{ref_api: field.refs, ref_key: field.refkey, required: field.required }"
                            ></refs-radio-list-component>
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                    </div>
                    <div v-if="field.data_type == 'address' || field.data_type == 'input-address'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group" id="AF_contain">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <address-finder-component
                                v-on:input="setFullAddress($event, field.name)"
                                :required="!!field.required"
                                :config="{ fulladdress: true, inputClass: 'form-control', container: true }"
                                :value="field.value"
                                :placeholder="_.isNull(_.get(field, 'placeholder')) ? 'Start typing your address' : field.placeholder"
                                ></address-finder-component>
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'textarea'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group">
                            <label :for="field.name" :class="[!showLabels ? 'd-none': '']">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <textarea v-model="formData[field.name]"
                                :name="field.name"
                                :id="field.name"
                                :placeholder="field.placeholder"
                                :required="!!field.required"
                                class="form-control"
                                rows="5"
                                :tabindex="_.get(field, 'tabindex', 1)"
                                ></textarea>
                            <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'radio-btn-group'"
                        :class="['d-flex flex-column', 'col-sm-' + _.get(field, 'cols', 12)]"
                        :key="field.name">
                        <label>
                            {{ field.title }}<sup v-if="field.required">*</sup>
                        </label>
                        <div class="btn-group row" data-toggle="buttons">
                            <div v-for="(option, index) in getSelectValues(field)"
                                :key="`btn-grp-${index}`"
                                class="btn-group-toggle mb-1 col">
                                <label class="container-radio container-radio-sm d-flex align-items-center my-2">
                                    <input v-model="formData[field.name]"
                                        :name="field.name + '_name'"
                                        :class="[field.required ? 'req' : '', 'form-control']"
                                        type="radio"
                                        :value="option.id"
                                        :required="!!field.required">
                                    <span class="checkmark mr-3"></span>
                                    {{ option.name }}
                                </label>
                            </div>
                        </div>
                        <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                    </div>
                    <div v-if="field.data_type == 'checkbox'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="form-group checkbox-group">
                            <div class="checkbox-inline">
                                <label  :for="field.name + '-' + field.id"
                                    class="container-checkbox-lg d-flex">
                                    <input v-on:input="(e) => updateCheckbox(field.name, e)"
                                        class="form-control"
                                        :checked="formData[field.name]"
                                        :name="field.name"
                                        :_placeholder="field.title"
                                        :id="field.name + '-' + field.id"
                                        :required="!!field.required"
                                        :value="1"
                                        type="checkbox"
                                        :tabindex="_.get(field, 'tabindex', 1)">
                                    <span class="checkmark mr-3"></span>
                                    {{ field.title }}
                                </label>
                            </div>
                        </div>
                        <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                    </div>
                    <div v-if="field.data_type == 'checkbox-multi'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <label>
                            {{ field.title }}<sup v-if="field.required">*</sup>
                        </label>
                        <div class="form-group checkbox-group">
                            <label v-for="(option, index) in getSelectValues(field)"
                                :key="`checkbox-grp-${index}`"
                                :for="option.id"
                                class="container-checkbox container-checkbox-sm d-flex align-items-center my-2">
                                <input v-on:input="(e) => updateCheckboxMulti(field.name, e)"
                                    class="form-control"
                                    :name="field.name"
                                    :required="!!field.required && _.isEmpty(formData[field.name])"
                                    :value="option.id"
                                    :id="option.id"
                                    type="checkbox">
                                <span class="checkmark mr-3"></span>
                                {{ option.name }}
                            </label>
                        </div>
                        <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                    </div>
                    <div v-if="field.data_type == 'file-upload'"
                        :key="field.name"
                        :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                        <div class="mb-4 field">
                            <label>
                                {{ field.title }}<sup v-if="field.required">*</sup>
                            </label>
                            <file-uploader-component
                                v-model="formData[field.name]"
                                :config="{
                                    field,
                                    inputId: field.name,
                                    fileTypes: getFileValues(_.get(field, 'extensions', ['jpg']))
                                }"
                                ></file-uploader-component>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'date-picker'"
                            :key="field.name"
                            :class="['col-12', 'col-sm-' + _.get(field, 'cols', 12)]">
                            <div class="mb-4">
                                <label>
                                    {{ field.title }}<sup v-if="field.required">*</sup>
                                </label>
                                <input class="form-control bootstrap-datepicker"
                                    v-model="formData[field.name]"
                                    :name="field.name"
                                    type="text"
                                    :id="field.name"
                                    autocomplete="off"
                                    :required="!!field.required"
                                    :tabindex="_.get(field, 'tabindex', 1)">
                                <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
                            </div>
                        </div>
                </template>
                </div>
            </fieldset>

            <div class="form-group mt-2">
                <button disabled :class="['btn', 'btn-primary', 'disabled', 'px-3', formLoading ? '' : 'd-none']"
                    >Please wait...</button>
                <button :data-sitekey="getRecaptchaKey()"
                    :class="[
                        'btn',
                        'btn-submit',
                        'btn-primary',
                        'px-4',
                        formLoading ? 'd-none' : ''
                    ]"
                    ref="form-btn"
                    data-theme="light"
                    type="button"
                    >{{ btnLabel }}</button>
            </div>
        </template>
    </form>
</template>

<script>
import UtilsMixin from '../UtilsMixin';
import AddressFinderComponent from './AddressFinderComponent';
import RefsRadioListComponent from './RefsRadioListComponent';
import FileUploaderComponent from './FileUploaderComponent';

export default{
    data() {
        let formData = {};
        // restore previous form data
        // formData = JSON.parse(window.localStorage.getItem('formData') || '{}');

        return {
            formHandler: 'submitForm' + Math.floor(Math.random() * 1000000),
            formData,
            localLoading: false,
            message: '',
            error: '',
            currentForm: {},
        }
    },

    props: ['initialData', 'config', 'loading'],

    components: {
        AddressFinderComponent,
        RefsRadioListComponent,
        FileUploaderComponent
    },

    mixins: [UtilsMixin],

    created() {
        _.chain(this.formConfig)
            .get('fields', [])
            .map(field => {
                let value = _.get(this.initialData, field.name, '');
                this.$set(this.formData, field.name, _.get(this.formData, field.name, ''))
            })
            .value();

        window[this.formHandler] = this.submitForm;
    },

    mounted() {

        $('.bootstrap-datepicker').datepicker({
            format: 'dd/mm/yyyy'
        }).change(this.dateChanged);

        // $('.selectpicker').selectpicker('toggle');
        this.$nextTick(() => {

            // Add Class to selectpicker
            $('.selectpicker').selectpicker('setStyle', 'form-control', 'add');

            $('bootstrap-select.show').on('keydown', function (e) {
                if (e.keyCode == 13) { // Enter
                    var elm = $(this);

                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == elm.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
                if (e.keyCode == 38) { // Up
                    var previousEle = $(this).prev();
                    if (previousEle.length == 0) {
                        previousEle = $(this).nextAll().last();
                    }
                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == previousEle.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
                if (e.keyCode == 40) { // Down
                    var nextEle = $(this).next();
                    if (nextEle.length == 0) {
                        nextEle = $(this).prevAll().last();
                    }
                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == nextEle.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
            });
        })

        this.registerRecaptcha();

    },

    computed: {
        formattedFields() {
            return _.get(this.formConfig, 'fields', []).map((field) => {
                if (field.value) {
                    this.formData[field.name] = field.value;
                }
                return field;
            });
        },

        formConfig() {
            return _.get(this, 'config', {});
        },

        formLoading() {
            return this.localLoading || this.loading;
        },

        btnLabel() {
            let label = _.get(this.formConfig, 'btnLabel', 'Get in touch');
            if (_.isNull(label)) {
                return 'Get in touch';
            }
            return label;
        },

        showMessage() {
            return _.get(this.formConfig, 'showMessage', true);
        },

        showLabels() {
            return _.get(this.formConfig, 'showLabels', true);
        },

        refreshBtn() {
            return _.get(this.config, 'refreshBtn', false);
        },

        successMessage() {
            let message = _.get(this.config, 'message', null);
            if (_.isNull(message)) {
                message = 'Your enquiry has been received and we will be in contact shortly.';
            }
            return message;
        },
    },

    methods: {

        dateChanged(e) {
            this.formData[e.target.name] = e.target.value;
        },

        getFileValues(values) {
            return _.isArray(values) ? values : _.split(values, '\n');
        },

        getSelectValues(field) {
            return this.formatValues(_.isArray(field.values) ? field.values : _.split(field.values, '\n'));
        },

        updateCheckbox(fieldname, e) {
            let value = e.target.checked * 1;
            this.formData[fieldname] = value;
        },

        updateCheckboxMulti(fieldname, e) {
            let val = e.target.value;
            if (!_.isArray(this.formData[fieldname])) {
                this.formData[fieldname] = [];
            }
            if (e.target.checked) {
                this.formData[fieldname].push(val);
            } else {
                _.remove(this.formData[fieldname], (value) => {
                    return value === val;
                });
            }
        },

        formatValues(values) {
            return values.map((val) => {
                if (!_.has(val.id)) {
                    return {
                        id: val,
                        name: val,
                    }
                }
                return val;
            });
        },

        submitForm(token) {
            let $form = $(this.$refs['form']);
            $form.addClass('was-validated');
            $form.find('label').each(function () {
                $(this).removeClass('is-invalid');
            });

            let $btn = $(this.$refs['form-btn']);

            if ($form[0].checkValidity()) {
                this.localLoading = true;
                let endpoint = _.get(this.formConfig, 'ajax', 'customer/post-form');
                let action = _.get(this.formConfig, 'action', 'SENDENQUIRY');
                window.localStorage.setItem('formData', JSON.stringify(this.formData));

                let formHandler = this.api.postData(`/../${endpoint}`, {}, _.assign({},
                    this.initialData,
                    this.formConfig,
                    this.formData, {
                        action,
                        form_id: this.config.id,
                        ['g-recaptcha-response']: token,
                    }));

                return formHandler
                    .then(res => {
                        this.handleFormInput(res, $form);
                        this.$emit('input', res);

                        // reset form data
                        $form.removeClass('was-validated');
                        _.chain(this.formConfig)
                            .get('fields', [])
                            .map(field => {
                                let value = _.get(this.initialData, field.name, '');
                                this.$set(this.formData, field.name, '')
                            })
                            .value();

                    })
                    .catch(err => {
                        this.handleFormError(err, $form);
                        this.$emit('error', err);
                    })
                    .finally(() => {
                        this.localLoading = false;
                    })
            } else {
                this.handleFormError(null, $form);
                $form.find('.btn-group-toggle input[type=radio], .checkbox-group input[type=checkbox]').each(function () {
                    if ($(this).is(":invalid")) {
                        $(this).parent('label').addClass('is-invalid');
                    }
                });

                $form.find('.custom-file-upload input[type=file]').each(function () {
                    if ($(this).is(":invalid")) {
                        $(this).next('.input-text').addClass('is-invalid');
                    }
                });
            }
        },

        getRecaptchaKey() {
            return window.env.GOOGLE_RECAPTCHA_KEY;
        },

        registerRecaptcha() {
            if (_.get(window.grecaptcha, 'render')) {
                this.initRecaptchaButton();
            }
            window.addEventListener('recaptcha-init', () => {
                this.initRecaptchaButton();
            })
        },

        initRecaptchaButton() {
            grecaptcha.render(this.$refs['form-btn'], {
                sitekey: this.getRecaptchaKey(),
                callback: this.submitForm,
            });
        },

        handleFormInput(res, form) {
            this.localLoading = false;
            this.message = '<p class="mb-0">' + this.successMessage + '</p>';
            window.localStorage.setItem('resource-form-data', JSON.stringify(res.data));
            window.fbq('track', 'Lead');

            this.scrollTo(form);
        },

        handleFormError(err, form) {
            this.localLoading = false;
            let res = _.get(err, 'response.data');
            let errors = _.chain(res).get('errors', [])
                .values()
                .flatMap(v => `<li>${v}</li>`)
                .join()
                .value();

            if (_.get(res, 'message')) {
                this.error = `
                    <p>${res.message}</p>
                    <ul>${errors}</ul>
                `;
            } else {
                this.error = 'There is something wrong with the form submission, please try again.';
            }

            let firstError = $('.form-control:invalid')[0];
            this.scrollTo(firstError);
        },

        scrollTo(elm) {
            var offsetSize = $('#header').height() + 50;
            return $('html, body').animate({
                scrollTop: $(elm).offset().top - offsetSize
            }, 400);
        },

        getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },

        setFullAddress(a, field) {
            this.$set(this.formData, field, a);
        },

        reloadPage() {
            window.location.reload();
        }
    },
}
</script>

<style scoped>

</style>
